export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;
export const SUNSET_API_DOMAIN = process.env.REACT_APP_SUNSET_API_DOMAIN;

export const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
export const AUTH0_CALLBACK_URL = process.env.REACT_APP_AUTH0_CALLBACK_URL;